import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { dataFormatters } from "../../utils/dataFormatters";
import SiteReportInfoSectionContextProviderContainer, { SiteReportInfoSectionContext } from "./SiteReportInfoSectionProvider";
import { SignatureImageImproved } from "../../components/Reports/utils/SignatureImage";
import { languageService } from "../../Language/language.service";
import { versionInfo } from "../../components/MainPage/VersionInfo";

// The ReportInfoSectionView component displays detailed information about a site report.
class ReportInfoSectionView extends Component {
  // When the component mounts, it calls the getInfoSection method from the context to fetch the report information.
  componentDidMount() {
    const { getInfoSection } = this.context;
    getInfoSection && getInfoSection();
  }

  render() {
    // Destructure the necessary information from the context
    const {
      railroadName,
      lineName,
      milepostWithPrefix,
      location,
      name,
      assetId,
      assetType,
      date,
      entryDate,
      equip,
      signatureImage,
      switchModel,
      installDate,
      buss,
      battInstallDate,
      additionalAttributes,
      certifiedBy,
      certifiedPerformedDate,
      employeeNumber,
      substationId,
      tourNumber,
    } = this.context;

    return (
      <Row>
        <Col md={12}>
          {/* Main container for the report information section */}
          <div className="fra-info-section" style={{ display: "flex", padding: "5px" }}>
            <div className="fra-info-section-left">
              <div className="heading-info">
                <strong>Railroad:</strong>
                <span className="pd-left-10px">{railroadName}</span>
              </div>
              {/* Line/Subdivision Name */}
              <div className="heading-info">
                <strong>Subdivision:</strong>
                <span className="pd-left-10px">{lineName}</span>
              </div>
              {/* Milepost with Prefix */}
              {!versionInfo.isReVAMP() && (
                <div className="heading-info">
                  <strong>Milepost (with Prefix):</strong>
                  <span className="pd-left-10px">{milepostWithPrefix}</span>
                </div>
              )}
              {/* Employee's Name */}
              <div className="heading-info">
                <strong>Employee’s Name:</strong>
                <span className="pd-left-10px">{name}</span>
              </div>
              {employeeNumber && (
                <div className="heading-info">
                  <strong>Badge Number:</strong>
                  <span className="pd-left-10px">{employeeNumber}</span>
                </div>
              )}
              {/* BUSS field, shown conditionally */}
              {buss && (
                <div className="heading-info">
                  <strong>BUSS:</strong>
                  <span className="pd-left-10px">{buss}</span>
                </div>
              )}
              {/* Battery Installation Date, shown conditionally */}
              {battInstallDate && (
                <div className="heading-info">
                  <strong>Batt. Install Date:</strong>
                  <span className="pd-left-10px">{battInstallDate}</span>
                </div>
              )}
              {/* Additional Attributes (odd-indexed), shown conditionally */}
              {additionalAttributes &&
                additionalAttributes.length > 0 &&
                additionalAttributes.map((attr, i) => {
                  return (
                    i % 2 === 0 && (
                      <div className="heading-info">
                        <strong>{attr.name}:</strong>
                        <span className="pd-left-10px">{attr.value}</span>
                      </div>
                    )
                  );
                })}
              {/* Signature Image */}
              <div className="heading-info" style={{ display: "flex", flexDirection: "row" }}>
                <strong>Signature:</strong>
                <span className="pd-left-10px">
                  <SignatureImageImproved signatureImage={signatureImage} width="60%" />{" "}
                </span>
              </div>
            </div>
            <div className="fra-info-section-right">
              {!versionInfo.isReVAMP() && (
                <div className="heading-info">
                  <strong>{languageService("Asset ID")}:</strong>
                  <span className="pd-left-10px">{assetId}</span>
                </div>
              )}
              {substationId !== null && (
                <div className="heading-info">
                  <strong>Substation ID:</strong>
                  <span className="pd-left-10px">{languageService(substationId)}</span>
                </div>
              )}
              {/* Asset Type, translated via languageService */}
              <div className="heading-info">
                <strong>Asset Type:</strong>
                <span className="pd-left-10px">{languageService(assetType)}</span>
              </div>
              {/* Location */}
              <div className="heading-info">
                <strong>{versionInfo.isReVAMP() ? "Asset:" : "Location:"}</strong>
                <span className="pd-left-10px">{location}</span>
              </div>
              {certifiedBy && (
                <div className="heading-info">
                  <strong>Certified By:</strong>
                  <span className="pd-left-10px">{dataFormatters.dateFormatter(certifiedBy)}</span>
                </div>
              )}
              {/* Test Date, formatted via dataFormatters */}
              <div className="heading-info">
                <strong>{certifiedPerformedDate ? "Certified Date:" : "Test Date:"}</strong>
                <span className="pd-left-10px">{dataFormatters.dateFormatter(date)}</span>
              </div>

              {/* Entry Date, shown conditionally and formatted */}
              {(entryDate || certifiedPerformedDate) && (
                <div className="heading-info">
                  <strong>Entry Date:</strong>
                  <span className="pd-left-10px">{dataFormatters.dateFormatter(entryDate || certifiedPerformedDate)}</span>
                </div>
              )}
              {/* Equipment Listed, shown conditionally */}
              {equip && (
                <div className="heading-info">
                  <strong>Equipment Listed:</strong>
                  <span className="pd-left-10px">{equip}</span>
                </div>
              )}
              {/* Switch Model, shown conditionally */}
              {switchModel && (
                <div className="heading-info">
                  <strong>Switch Model:</strong>
                  <span className="pd-left-10px">{switchModel}</span>
                </div>
              )}
              {/* Installation Date, shown conditionally */}
              {installDate && (
                <div className="heading-info">
                  <strong>Install Date:</strong>
                  <span className="pd-left-10px">{installDate}</span>
                </div>
              )}
              {tourNumber !== null && (
                <div className="heading-info">
                  <strong>Tour No:</strong>
                  <span className="pd-left-10px">{languageService(tourNumber)}</span>
                </div>
              )}

              {/* Additional Attributes (even-indexed), shown conditionally */}
              {additionalAttributes &&
                additionalAttributes.length > 0 &&
                additionalAttributes.map((attr, i) => {
                  return (
                    i % 2 !== 0 && (
                      <div className="heading-info">
                        <strong>{attr.name}:</strong>
                        <span className="pd-left-10px">{attr.value}</span>
                      </div>
                    )
                  );
                })}
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
// Set the context type to access the SiteReportInfoSectionContext
ReportInfoSectionView.contextType = SiteReportInfoSectionContext;

// Container component to provide the context to ReportInfoSectionView
export default class ReportFraInfoSectionContainer extends Component {
  render() {
    return (
      <SiteReportInfoSectionContextProviderContainer {...this.props}>
        <ReportInfoSectionView />
      </SiteReportInfoSectionContextProviderContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/ReportFraInfoSection.jsx